import React, { useEffect } from 'react';
import { useParams, useLocation } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';
import { useUpdateAppointmentStatusMutation } from '../services/appointmentService';
import { replaceNewLinesToLineBreaks } from '../helpers/TemplateHelpers';

const AppointmentReminderAck = () => {
  const params = useParams();
  const location = useLocation();
  const [acknowlegement, setAcknowlegement] = React.useState('');
  const [updateAppointmentStatus, data] = useUpdateAppointmentStatusMutation();

  const { message } = data?.error?.data || {};

  useEffect(() => {
    if (location.pathname.includes('confirm')) {
      setAcknowlegement('Your appointment is confirmed.');
      updateAppointmentStatus({ shortCode: params.shortCode, status: 'confirm' });
    } else if (location.pathname.includes('cancel')) {
      setAcknowlegement('You have successfully canceled your appointment. \n Please contact the office to reschedule.');
      updateAppointmentStatus({ shortCode: params.shortCode, status: 'cancel' });
    }
  }, [location.pathname]);

  return (
    <div className="app-page">
      <div className="app-panels">
        <div className="list-panel__wrapper">
          <div className="empty-message__wrapper">
            <div className="empty-message__content">
              {data.status === 'rejected' && (
                <h3 style={{ color: 'red' }}>Expired</h3>
              )}
              {data.status === 'fulfilled' && (
                <h3>Thank You</h3>
              )}
              {data.status === 'rejected' && (
                <p className="u-text-large">{ReactHtmlParser(replaceNewLinesToLineBreaks(message))}</p>
              )}
              {data.status === 'fulfilled' && (
                <p className="u-text-large">{ReactHtmlParser(replaceNewLinesToLineBreaks(acknowlegement))}</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppointmentReminderAck;
